export enum ROLES {
  ADMIN = "admin",
  USER = "user",
}
